// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1W0qb","clinicsSelect":"TableHeading_clinicsSelect__1u4sp"};